import {lazy} from '@aboutyou/lazy-imports';
import {Header as TadaridaHeader} from '@aboutyou/logic-components';
import {ErrorBoundary} from '@aboutyou/ui-components';
import React, {useCallback} from 'react';

export const EnableSettingsModal = lazy(() =>
  import('../../../../bridge/global/Header/Flyouts/EnableSettingsModal').then(
    mod => ({default: mod.EnableSettingsModal}),
  ),
);

export const Header: React.FC = () => {
  const enableSettingsModal = useCallback(props => {
    return (
      <ErrorBoundary renderContext="settings_modal" ErrorComponent={null}>
        <EnableSettingsModal {...props} />
      </ErrorBoundary>
    );
  }, []);

  return (
    <TadaridaHeader
      enableSettingsModalComponent={enableSettingsModal}
      voucherToastsShowDirection="down"
    />
  );
};
